import { https } from 'mk-biz-pc'
import { Config } from './config'

const coreApi = https.coreApi

/**
 * 获取应用列表
 * @returns
 */
export const getAppList = () => coreApi(Config.getAppList)

/**
 * 查询应用列表
 * @param params
 * @returns
 */
export const queryAppList = (params: any) => coreApi(Config.queryAppList, { params })
